module.exports = __webpack_public_path__ + "img/spartan-demolition-sitework-04-xlarge.ea81ae47.jpg";